import { useDeferredValue, useEffect, useState } from "react";
import { useAction } from "next-safe-action/hooks";
import { useRouter } from "next/navigation";
import { toast } from "sonner";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverAnchor, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { searchWorkspacesAction } from "@/actions/search-workspaces";
import { switchWorkspaceAction } from "@/actions/switch-workspace";
import { useCurrentUser } from "@/lib/auth/client";
import { Button } from "@/components/ui/button";
import { Icon } from "../ui/icon";
export function WorkspaceSwitcher() {
  const user = useCurrentUser();
  const [open, setOpen] = useState(false);
  const [workspace, _setWorkspace] = useState(user.client);
  const [workspaces, setWorkspaces] = useState([]);
  const {
    execute: executeSearchWorkspaces,
    isPending: isSearchWorkspacesPending
  } = useAction(searchWorkspacesAction, {
    onSuccess: ({
      data
    }) => {
      data && setWorkspaces(data);
    },
    onError: ({
      error
    }) => {
      console.error(error);
      toast.error("Error searching for workspaces, please try again.");
    }
  });
  const {
    execute: executeSwitchWorkspace,
    isPending: isSwitchWorkspacePending
  } = useAction(switchWorkspaceAction, {
    onSuccess: ({
      data: data_0
    }) => {
      if (data_0?.redirectUrl) {
        window.location.href = data_0.redirectUrl;
      } else {
        toast.error("Error switching to workspace, please try again.");
      }
    },
    onError: ({
      error: error_0
    }) => {
      console.error(error_0);
      toast.error("Error switching to workspace, please try again.");
    }
  });
  const [query, setQuery] = useState("");
  const router = useRouter();
  const deferedQuery = useDeferredValue(query);
  useEffect(() => {
    // Only search if dropdown is open or if there's an actual query
    if (open || deferedQuery.trim()) {
      executeSearchWorkspaces(deferedQuery);
    }
  }, [deferedQuery, open, executeSearchWorkspaces]);
  const onSelect = name => {
    setOpen(false);
    const workspaceId = workspaces.find(w => w.name === name)?.id;
    executeSwitchWorkspace(Number(workspaceId));
  };
  return <>
      <Popover open={open} onOpenChange={setOpen}>
        <div className="flex items-center">
          <PopoverAnchor></PopoverAnchor>
          <PopoverTrigger asChild>
            <Button variant={"ghost"} disabled={isSwitchWorkspacePending}>
              {workspace.name}
              <Icon icon="lucide:chevrons-up-down" className="ml-2 h-4 w-4 text-slate-9" />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="p-0" side="right" align="start">
            <Command>
              <CommandInput placeholder="Switch to..." onValueChange={setQuery} />
              <CommandList>
                <CommandEmpty>
                  {isSearchWorkspacesPending ? "Searching..." : "No results found."}
                </CommandEmpty>
                <CommandGroup>
                  {workspaces.map(workspace_0 => <CommandItem key={workspace_0.id} value={workspace_0.name} onSelect={onSelect}>
                      {workspace_0.name}
                    </CommandItem>)}
                </CommandGroup>
              </CommandList>
            </Command>
          </PopoverContent>
        </div>
      </Popover>
    </>;
}